import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MuiCard from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { TICKET_SYSTEM_BASE_URL } from "../../Constants/Constants";
import { SSOIcon } from "../v2/sign-in-side/components/CustomIcons";
import ForgotPassword from "./ForgotPassword";

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  [theme.breakpoints.up("sm")]: {
    width: "450px",
  },
  ...theme.applyStyles("dark", {
    boxShadow:
      "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  }),
}));

export default function SignInCard(props) {
  const [userNameError, setUserNameError] = React.useState(false);
  const [userNameErrorMessage, setUserNameErrorMessage] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSSOLogin = () => {
    //window.location.href = TICKET_SYSTEM_BASE_URL + "/api/sso-login";
    const baseUrl = process.env.REACT_APP_API_BASE_URL || "";

    window.location.href = `${baseUrl}/api/sso-login`;
  };

  const validateInputs = () => {
    const { username, password } = props.formData;
    let isValid = true;
    if (!username || username.trim() === "") {
      setUserNameError(true);
      setUserNameErrorMessage("Username is required.");
      isValid = false;
    } else {
      setUserNameError(false);
      setUserNameErrorMessage("");
    }
    if (!password || password.trim() === "") {
      setPasswordError(true);
      setPasswordErrorMessage("Password is required.");
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }
    return isValid;
  };

  const handleUserNameChange = (event) => {
    setUserNameError(false);
    setUserNameErrorMessage("");
    props.handleChange(event);
  };

  const handlePasswordChange = (event) => {
    setPasswordError(false);
    setPasswordErrorMessage("");
    props.handleChange(event);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    props.setApiError(null);

    if (validateInputs()) {
      props.handleSubmit(event);
    }
  };

  return (
    <Card variant="outlined">
      <Box sx={{ display: { xs: "flex", md: "none" } }}></Box>
      <Typography
        component="h1"
        variant="h4"
        sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
      >
        Sign in
      </Typography>
      <Box
        component="form"
        onSubmit={handleFormSubmit}
        noValidate
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: 2,
        }}
      >
        <FormControl>
          <FormLabel htmlFor="username" required>
            Username
          </FormLabel>
          <TextField
            error={userNameError}
            helperText={userNameErrorMessage}
            id="username"
            type="username"
            name="username"
            value={props.formData.username}
            placeholder="username"
            autoComplete="username"
            autoFocus
            required
            fullWidth
            variant="outlined"
            color={userNameError ? "error" : "primary"}
            onChange={handleUserNameChange}
          />
        </FormControl>
        <FormControl>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <FormLabel htmlFor="password" required>
              Password
            </FormLabel>
            <Link
              component="button"
              type="button"
              onClick={handleClickOpen}
              variant="body2"
              tabIndex={-1}
              sx={{ alignSelf: "baseline" }}
            >
              Forgot your password?
            </Link>
          </Box>
          <TextField
            error={passwordError}
            helperText={passwordErrorMessage}
            name="password"
            placeholder="••••••"
            type="password"
            id="password"
            value={props.formData.password}
            autoComplete="current-password"
            fullWidth
            variant="outlined"
            color={passwordError ? "error" : "primary"}
            onChange={handlePasswordChange}
          />
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox tabIndex={-1} value="remember" color="secondary" />
          }
          label="Remember me"
        />
        <ForgotPassword open={open} handleClose={handleClose} />
        <Button type="submit" fullWidth variant="contained">
          Sign in
        </Button>
        {props.apiError && (
          <Typography
            color="error"
            variant="body2"
            sx={{ textAlign: "center", mb: 1 }}
          >
            {props.apiError}
          </Typography>
        )}
      </Box>
      <Divider>or</Divider>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleSSOLogin}
          startIcon={<SSOIcon />}
        >
          Login with SSO
        </Button>
      </Box>
    </Card>
  );
}
